module.exports = __webpack_public_path__ + "img/boss.44b6b68f.png";